<template>
  <div class="px-8 py-1">
    <v-container grid-list-xl fluid class="px-0">
      <v-flex xs12 mb-3>
        <h2 class="darkblue--text fs-16 lh-16 font-weight-700">
          TAXONOMY
        </h2>
        <v-breadcrumbs class="px-0" :items="breadcrumbs"></v-breadcrumbs>
      </v-flex>
      <v-card>
        <v-card-title>
          <v-flex xs9>
            Taxonomy Details
          </v-flex>
          <v-flex xs3 class="text-right">
            <v-icon id="refresh" title="refresh" @click="getDetail()">
              refresh
            </v-icon>
          </v-flex>
        </v-card-title>
        <v-flex xs12 class="pa-7">
          <v-layout row wrap>
            <table width="80%">
              <tr>
                <td width="20%">Code</td>
                <td width="5%">:</td>
                <td width="60%" class="grey--text">{{ taxonomy.code }}</td>
              </tr>
              <tr>
                <td>PCTR</td>
                <td>:</td>
                <td class="grey--text">{{ taxonomy.pctr }}</td>
              </tr>
              <tr>
                <td>MAT Group</td>
                <td>:</td>
                <td class="grey--text">{{ taxonomy.mat_group }}</td>
              </tr>
              <tr>
                <td>AR 1</td>
                <td>:</td>
                <td class="grey--text">{{ taxonomy.ar1 }}</td>
              </tr>
              <tr>
                <td>BPC</td>
                <td>:</td>
                <td class="grey--text">{{ taxonomy.bpc }}</td>
              </tr>
              <tr>
                <td>Code Cost Element</td>
                <td>:</td>
                <td class="grey--text">{{ taxonomy.code_cost_element }}</td>
              </tr>
              <tr>
                <td>Cost Element Desc</td>
                <td>:</td>
                <td class="grey--text">
                  {{ taxonomy.costElement ? taxonomy.costElement.desc : '-' }}
                </td>
              </tr>
              <tr>
                <td>Code Cost Center</td>
                <td>:</td>
                <td class="grey--text">{{ taxonomy.code_cost_center }}</td>
              </tr>
              <tr>
                <td>Cost Center Desc</td>
                <td>:</td>
                <td class="grey--text">
                  {{ taxonomy.costCenter ? taxonomy.costCenter.desc : '-' }}
                </td>
              </tr>
              <tr>
                <td>Category</td>
                <td>:</td>
                <td class="grey--text">
                  {{ taxonomy.category ? taxonomy.category : '-' }}
                </td>
              </tr>
            </table>
          </v-layout>
        </v-flex>
        <v-card-actions class="text-right">
          <v-spacer></v-spacer>
          <v-flex xs2 right class="mr-8 mb-5">
            <v-btn
              id="btn-cancel"
              dark
              rounded
              color="red"
              block
              :to="{ name: 'taxonomy' }"
            >
              Back
            </v-btn>
          </v-flex>
        </v-card-actions>
      </v-card>
    </v-container>
    <progress-dialog :show="progressDialogLoading" text="Please wait">
    </progress-dialog>
  </div>
</template>

<script>
import Swal from 'sweetalert2';
import ProgressDialog from '../../../components/progress_dialog';

export default {
  $_veeValidate: {
    validator: 'new'
  },
  props: ['id'],
  components: { 'progress-dialog': ProgressDialog },
  data() {
    return {
      name: '',
      loading: true,
      progressDialogLoading: true,
      search: '',
      breadcrumbs: [
        {
          text: 'Master Data',
          disabled: true,
          href: 'breadcrumbs_dashboard'
        },
        {
          text: 'Taxonomy Detail',
          disabled: true,
          href: 'breadcrumbs_link_1'
        }
      ],
      taxonomy: {}
    };
  },
  mounted() {
    this.getDetail();
  },
  methods: {
    getDetail() {
      this.progressDialogLoading = true;
      this.loading = true;
      this.$store
        .dispatch('taxonomy/detail', this.id)
        .then(data => {
          if (data.code === 200) {
            this.taxonomy = data.data.result;
            this.progressDialogLoading = false;
            this.loading = false;
          } else {
            this.progressDialogLoading = false;
            this.loading = false;
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          console.log(err.response);
          this.progressDialogLoading = false;
          this.loading = false;
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
        });
    }
  }
};
</script>
